import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const get = async (path, params) => {
  const response = await axios.get(`${API_URL}/dashboard/${path}`, {
    ...getAuthHeaders(),
    params,
  });
  const body = response.data;
  if (body?.state === false) {
    throw new Error(body?.message || 'No se pudo obtener la información');
  }
  return body?.data ?? body;
};

export const getPersonalTrabajando = (fecha) => get('personal-trabajando', { fecha });

export const getConductores = (desde, hasta) => get('conductores', { desde, hasta });

export const getProduccion = (desde, hasta) => get('produccion', { desde, hasta });

export const getTendencia = (dias = 7) => get('tendencia', { dias });

export const getCalidad = (dias = 7) => get('calidad', { dias });

export const getServiciosPublicos = (fecha) => get('servicios-publicos', { fecha });

export const getPlanificacionTurnos = (fecha) => get('planificacion-turnos', { fecha });

export const getPlanificacionCentro = (centroId, fecha) =>
  get(`planificacion-turnos/${centroId}`, { fecha });

export const getCumplimientoHoras = (mes) => get('cumplimiento-horas', { mes });

export const getCentrosCumplimientoHoras = () => get('cumplimiento-horas/centros');

// Costo estimado de la nómina del mes (planeado vs. proyectado) con el motor de nómina.
// centros: ids separados por coma de los centros que se muestran.
export const getCostoNominaMes = async (mes, centros) => {
  const response = await axios.get(`${API_URL}/nomina/estimado-mes`, {
    ...getAuthHeaders(),
    params: { mes, centros },
  });
  const body = response.data;
  if (body?.state === false) throw new Error(body?.message || 'No se pudo calcular el costo de la nómina');
  return body?.data ?? body;
};

// Filtro de centros por sección del panel (compartido por todos los usuarios).
export const getResumenSecciones = () => get('secciones/resumen');

export const getCentrosSeccion = (seccion) => get(`secciones/${seccion}/centros`);

export const setCentrosSeccion = async (seccion, incluidos) => {
  const response = await axios.put(
    `${API_URL}/dashboard/secciones/${seccion}/centros`,
    { incluidos },
    getAuthHeaders(),
  );
  const body = response.data;
  if (body?.state === false) {
    throw new Error(body?.message || 'No se pudo guardar la selección');
  }
  return body?.data ?? body;
};

export const getFotosAleatorias = ({ fecha, centro, cantidad } = {}) =>
  get('fotos-aleatorias', { fecha, centro, cantidad });

export const setCentrosCumplimientoHoras = async (analizados) => {
  const response = await axios.put(
    `${API_URL}/dashboard/cumplimiento-horas/centros`,
    { analizados },
    getAuthHeaders(),
  );
  const body = response.data;
  if (body?.state === false) {
    throw new Error(body?.message || 'No se pudo guardar la configuración');
  }
  return body?.data ?? body;
};

// ---- Agentes de análisis (RR. HH., Productividad, Gerencia) ----
const agentes = async (method, path, body) => {
  const response = await axios({
    method,
    url: `${API_URL}/agentes${path}`,
    data: body,
    ...getAuthHeaders(),
  });
  const resp = response.data;
  if (resp?.state === false) {
    const error = new Error(resp?.message || 'No se pudo completar la solicitud');
    error.data = resp?.data;
    throw error;
  }
  return resp?.data ?? resp;
};

export const getAgentes = () => agentes('get', '');

export const analizarAgente = (area) => agentes('post', `/${area}/analizar`);

export const preguntarAgente = (area, pregunta, historial) =>
  agentes('post', `/${area}/preguntar`, { pregunta, historial });

export const getHistorialAgente = (area, limite = 10) =>
  agentes('get', `/${area}/historial?limite=${limite}`);

export const getContextoAgente = (area) => agentes('get', `/${area}/contexto`);

// Indicaciones del equipo para los agentes (persistentes): general y por área.
export const getIndicacionesAgentes = () => agentes('get', '/indicaciones');

export const guardarIndicacionAgente = (ambito, datosIndicacion) =>
  agentes('put', `/indicaciones/${ambito}`, datosIndicacion);

// Objetivos del mes que siguen los agentes.
export const getObjetivosAgentes = (mes) =>
  agentes('get', `/objetivos${mes ? `?mes=${encodeURIComponent(mes)}` : ''}`);

export const crearObjetivoAgentes = (objetivo) => agentes('post', '/objetivos', objetivo);

export const actualizarObjetivoAgentes = (id, objetivo) =>
  agentes('put', `/objetivos/${id}`, objetivo);

export const eliminarObjetivoAgentes = (id) => agentes('delete', `/objetivos/${id}`);

// Configuración de indicadores de los centros (solo lectura; se edita con el modal de
// Parametrización → Centros de lavado).
export const getMetasCentros = () => agentes('get', '/metas-centros');

